import {Button} from 'reactstrap';
import './styles.css';
import {useNavigate} from 'react-router-dom';

import {NAMESPACES_PATH} from 'src/routes';

export const WelcomeWizard = () => {
  const navigate = useNavigate();
  return (
    <div className='WelcomeWizard'>
      <div className='WelcomeWizard__container'>
        <h2>Welcome to CodeLogic!</h2>
        <p>
          CodeLogic analyzes your applications, databases, and shared libraries to provide powerful insights into your dependencies, but first it needs to be configured to ensure that it is only scanning what is relevant in your environment.
        </p>
        <p>
          On the following screens, the installer will walk you through the following steps:
          <ul>
            <li>Define Namespaces for Java & .Net</li>
            <li>Configure default agent settings</li>
            <li>Scan applications and databases</li>
          </ul>
          Please gather the following information before starting:
          <ul>
            <li>Namespaces used by your applications</li>
            <li>Application artifacts, such as JARs or DLLs</li>
            <li>Database credentials</li>
          </ul>
        </p>
        <h5 className='WelcomeWizard__continuation-prompt'>
          Ready? Let&apos;s get started!
        </h5>
      </div>
      <Button className='WelcomeWizard__continue-button' color='primary' onClick={() => navigate(NAMESPACES_PATH)}>Next</Button>
    </div>
  );
};
